import { render, staticRenderFns } from "./ReportEducationFilter.vue?vue&type=template&id=0ca3970e&"
import script from "./ReportEducationFilter.vue?vue&type=script&lang=ts&"
export * from "./ReportEducationFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports